import { PInputText } from 'components/prime/PInputText/PInputText';
import React from 'react';
import { useUploadStepBLoC } from '../../../../UploadStep.bloc';
import { TypeOfDataImportNameInputStyle as S } from './TypeOfDataImportNameInput.style';
import { FormField } from 'components/FormField/FormField';
import { VStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';

export const TypeOfDataImportNameInput: React.FC = () => {
  const { uploadForm } = useUploadStepBLoC();
  return (
    <S.Container>
      <FormField
        form={uploadForm}
        label="Import name"
        controller={{
          name: 'name',
          rules: {
            required: 'Import name is required',
            maxLength: 255,
          },
        }}
      >
        {({ field, fieldState }) => (
          <VStack gap="gap2">
            <Text color="neutral400" size="fontSizeSM" lineHeight="lineHeightMD">
              Use a name that you can keep track of multiple updates
            </Text>
            <PInputText
              {...field}
              invalid={fieldState.invalid}
              placeholder="E.g. Employee NPS March"
              maxLength={255}
              onBlur={() => field.onChange(field.value.trim())}
            />
          </VStack>
        )}
      </FormField>
    </S.Container>
  );
};
